import type { BlogStrings } from "../../types";

export const blog: BlogStrings = {
  index: {
    title: "Blog",
    subtitle: "Releases, design notes, and stories from building CATE.",
    empty: "No posts yet. Check back soon.",
    latest: "Latest",
    releases: "Releases",
    releasesAll: "all →",
    pastArticles: "Past articles",
    pastHint: "drag to rearrange · click to open",
  },
  post: {
    back: "← Blog",
    by: "By",
    morePosts: "← More posts",
    keepReading: "Keep reading",
    notFoundTitle: "Post not found",
    notFoundBody: "That post doesn't exist or may have moved.",
    notFoundBack: "← Back to the blog",
  },
  release: {
    notFoundTitle: "Release not found",
    notFoundBody: "No release matches v{version}.",
    notFoundBack: "← Back to the blog",
    whatsIn: "What's in this release",
    download: "Download v{version}",
    readStory: "Read the full story →",
    levelMajor: "Major release",
    levelMinor: "Minor release",
    levelPatch: "Patch",
  },
};
